import { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

import ContextNLCode from './ContextRapidNLCodeExt';
import transformKeys from '../insurance-nlcode/util/transformKeys';

import LayoutRapidNLExt from './LayoutRapidNLExt';
import usePkg from 'hook/usePkg';
import { useRapidNLCode } from 'api/rapid/getNLCode';
import { useRapidCreateOrder } from 'api/rapid/postOrder';

const currDate = new Date();

function RapidALcode() {
  const navigate = useNavigate();
  const { options } = usePkg();
  const [alcode, setAlcode] = useState('');
  const [parseData, setParseData] = useState([]);
  const [policyDate, setPolicyDate] = useState(currDate);
  const [pkg, setPkg] = useState(options[0]);
  const [disabled, setDisabled] = useState(true);
  const [isPass, setIsPass] = useState(false);
  const { refetch } = useRapidNLCode(undefined, alcode);
  const [toggle, setToggle] = useState(true);
  const [addresed, setIsAddressed] = useState(false);
  const [employer, setEmployer] = useState('');
  const [employerId, setEmployerId] = useState('');
  const [address1, setAddress1] = useState('');
  const [district, setDistrict] = useState('');
  const [area, setArea] = useState('');
  const [province, setProvince] = useState('');
  const [zipcode, setZipcode] = useState('');
  const [selectedData, setSelectedData] = useState([]);
  const { mutateAsync: createOrder } = useRapidCreateOrder();

  useEffect(() => {
    setDisabled(true);
    setIsPass(false);
  }, []);

  useEffect(() => {
    if (alcode.length === 13) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [alcode]);

  useEffect(() => {
    if (!employer || !address1 || !district || !area || !province || !zipcode) {
      setIsAddressed(false);
    } else {
      setIsAddressed(true);
    }
    console.log(`${employer}`);
  }, [employer, address1, district, area, province, zipcode]);

  function getNamelist() {
    Swal.fire({
      title: 'กำลังดำเนินการ',
      timerProgressBar: true,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
        refetch()
          .then((data) => {
            if (data.isError) {
              throw data.error;
            }
            if (process.env.NODE_ENV !== 'production') {
              console.log(data.data);
            }
            setParseData(transformKeys(data.data, policyDate, pkg?.value));
            Swal.fire('สำเร็จ', '', 'success');
          })
          .catch((err) => {
            Swal.close();
            let errMsg = handleAxios(err);
            Swal.fire('ล้มเหลว', `${errMsg !== '' ? errMsg : err?.response}`, 'error');
          });
      },
    });
  }

  function handleSubmit() {
    const newSwal = Swal.mixin({
      customClass: {
        confirmButton: 'button button-success',
        cancelButton: 'button button-error',
      },
      buttonsStyling: false,
    });

    newSwal
      .fire({
        title: 'ข้อมูลถูกต้อง?',
        text: '',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
      })
      .then((result) => {
        if (result.isConfirmed) {
          // NOTE: navigate here
          const data = toggle
            ? [{ ...parseData[0], employer, employerId, address1, district, area, province, zipcode }]
            : parseData;
          createOrder({
            data,
          }).then((res) => {
            Swal.fire('สำเร็จ', 'ทำการชำระเงิน', 'success')
              .then(() => {
                setParseData([]);
                setDisabled(true);
                setIsPass(false);
                setAddress1('');
                setEmployer('');
                setEmployerId('');
                setDistrict('');
                setArea('');
                setProvince('');
                setZipcode('');
                navigate('/rapid/payment/' + res.invoiceId);
              })
              .catch((err) => {
                Swal.close();
                let errMsg = handleAxios(err);
                Swal.fire('ล้มเหลว', `${errMsg !== '' ? errMsg : err?.response}`, 'error');
              });
          });
        }
      });
  }

  function handleSelected(data) {
    const value = data.map((d) => d.original);
    setSelectedData(value);
  }

  function handleRemove() {
    let difference = getDifference(parseData, selectedData);
    setParseData(difference);
    setSelectedData([]);
  }

  function handleRemoveAll() {
    setParseData([]);
    setSelectedData([]);
  }

  function getDifference(arr1, arr2) {
    const makeDiff = (array1, array2) =>
      array1.filter((object1) => !array2.some((object2) => object1.idCard === object2.idCard));
    return [...makeDiff(arr1, arr2), ...makeDiff(arr2, arr1)];
  }

  function handleAxios(err) {
    let errMsg;
    if (axios.isAxiosError(err)) {
      if (err.response?.data) {
        errMsg = err.response.data;
      }
    }
    return errMsg;
  }

  return (
    <ContextNLCode.Provider
      value={{
        alcode,
        setAlcode,
        policyDate,
        setPolicyDate,
        pkg,
        setPkg,
        isPass,
        disabled,
        getNamelist,
        handleSubmit,
        toggle,
        setToggle,
        parseData,
        setParseData,
        employer,
        setEmployer,
        employerId,
        setEmployerId,
        address1,
        setAddress1,
        district,
        setDistrict,
        area,
        setArea,
        province,
        setProvince,
        zipcode,
        setZipcode,
        handleRemove,
        handleRemoveAll,
        handleSelected,
        addresed,
      }}
    >
      <LayoutRapidNLExt />
    </ContextNLCode.Provider>
  );
}

export default RapidALcode;
